import axios from "axios";

// APLA APPLICATION START
export async function requestShowAPLAApplication(teamId, id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/@apla/${teamId}/applications/${id}`);
}

export async function requestRedeployAPLAApplication(teamId, id) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/@apla/${teamId}/applications/${id}/redeploy`
	);
}

export async function requestStartAPLAApplication(teamId, id) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/@apla/${teamId}/applications/${id}/start`
	);
}

export async function requestRestartAPLAApplication(teamId, id) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/@apla/${teamId}/applications/${id}/restart`
	);
}

export async function requestStopAPLAApplication(teamId, id) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/@apla/${teamId}/applications/${id}/stop`
	);
}

export async function requestUpdateAPLAApplication(teamId, id, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/@apla/${teamId}/applications/${id}/update`,
		payload,
		{ headers: { "Content-Type": "application/json" } }
	);
}

export async function requestUpdateAPLAApplicationDomains(teamId, id, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/@apla/${teamId}/applications/${id}/update-domains`,
		payload,
		{ headers: { "Content-Type": "application/json" } }
	);
}

export async function requestGetAPLAApplicationLogs(teamId, id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/@apla/${teamId}/applications/${id}/logs`);
}

export async function requestGetAPLAApplicationDeployments(teamId, id) {
	return await axios.get(
		`${import.meta.env.VITE_API_URL}/@apla/${teamId}/applications/${id}/deployments`
	);
}

export async function requestGetAPLAApplicationEnvironments(teamId, id) {
	return await axios.get(
		`${import.meta.env.VITE_API_URL}/@apla/${teamId}/applications/${id}/environments`
	);
}

export async function requestCreateAPLAApplicationEnvironment(
	teamId,
	id,
	{ key, value, isPreview }
) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/@apla/${teamId}/applications/${id}/environments/create`,
		{ key, value, isPreview },
		{ headers: { "Content-Type": "application/json" } }
	);
}

export async function requestUpdateAPLAApplicationEnvironment(teamId, id, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/@apla/${teamId}/applications/${id}/environments/update`,
		payload,
		{
			headers: {
				"Content-Type": "application/json",
			},
		}
	);
}

export async function requestDeleteAPLAApplicationEnvironment(teamId, id, envId) {
	return await axios.delete(
		`${
			import.meta.env.VITE_API_URL
		}/@apla/${teamId}/applications/${id}/environments/${envId}/delete`
	);
}
// APLA APPLICATION END
